import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import React from "react";
import { useAuthInternal } from "./AuthContext";
import { LoginCallback } from "./LoginCallback";
import { SilentCallback } from "./SilentCallback";
import { SilentLogin } from "./SilentLogin";
export var OidcRoutes = function (_ref) {
  var children = _ref.children,
    _oidc$configuration = useAuthInternal().oidc.configuration,
    silentLoginUri = _oidc$configuration.silent_login_uri,
    silentRedirectUri = _oidc$configuration.silent_redirect_uri,
    redirectUri = _oidc$configuration.redirect_uri,
    path = new _URL(window.location.href).pathname;
  return silentLoginUri && path === new _URL(silentLoginUri).pathname ? React.createElement(SilentLogin, null) : silentRedirectUri && path === new _URL(silentRedirectUri).pathname ? React.createElement(SilentCallback, null) : redirectUri && path === new _URL(redirectUri).pathname ? React.createElement(LoginCallback, null) : React.createElement(React.Fragment, null, children);
};
OidcRoutes.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "OidcRoutes"
}, OidcRoutes.__docgenInfo = {
  componentName: "OidcRoutes",
  packageName: "@jutro/auth",
  description: "",
  displayName: "OidcRoutes",
  methods: [],
  actualName: "OidcRoutes"
};